import {connect} from 'react-redux';
import {reduxForm} from 'redux-form';
import {ff, form} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";
import {withTranslation, WithTranslation} from "react-i18next";
const {Form, FormBody, FormActions} = form;

/**
 * Formulář pro tvorbu/úpravu nákladových středisek.
 */
class NakladoveStrediskoForm extends Component<WithTranslation> {

    static formName = 'NakladoveStrediskoForm';

    render() {
        const {onClose, submitting, handleSubmit, t} = this.props;
        return <Form onSubmit={handleSubmit} horizontal>
            <FormBody>
                <ff.String label={t('labels.code')} name="kodStredisko" required disabled={submitting}/>
                <ff.String label={t('labels.Name')} name="nazevStredisko" required disabled={submitting}/>
            </FormBody>
            <FormActions onClose={onClose} storeButton={t('save')} cancelButton={t('buttons.cancel')} disabled={submitting}/>
        </Form>
    }
}

export default withTranslation()(connect()(reduxForm({
    form: NakladoveStrediskoForm.formName,
})(NakladoveStrediskoForm)));
